module.exports = __webpack_public_path__ + "assets/1e1365c7135ba7dcfd84e2888e847db5.mp3";